module.exports = __webpack_public_path__ + "static/img/icon-01.19568b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/icon-01.png
// module id = QIJU
// module chunks = 1